import React from 'react';

export const with1dArrowNavigation = Component => (props) => {
    let minX = Infinity;
    let maxX = -Infinity;
    const refs = {};

    const setRef = x => (ref) => {
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
        refs[x] = ref;
    };

    const [currentId, setCurrentId] = React.useState(minX);

    const handleArrowLeft = () => setCurrentId(x => Math.max(minX, x - 1));
    const handleArrowUp = () => setCurrentId(x => Math.min(maxX, x + 1));
    const handleArrowRight = () => setCurrentId(x => Math.min(maxX, x + 1));
    const handleArrowDown = () => setCurrentId(x => Math.max(minX, x - 1));

    const handleKeyDown = (event) => {
        if (event.ctrlKey || event.shiftKey || event.altKey || event.metaKey) {
            return undefined;
        }

        if (event.keyCode >= 37 && event.keyCode <= 40) {
            event.preventDefault();
        }

        switch (event.keyCode) {
        case 37: return handleArrowLeft();
        case 38: return handleArrowUp();
        case 39: return handleArrowRight();
        case 40: return handleArrowDown();
        default: return undefined;
        }
    };

    const handleMouseDown = x => () => setCurrentId(x);

    React.useEffect(() => {
        if (refs[currentId]) refs[currentId].focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentId]);

    return (
        <Component
            {...props}
            navigation={{
                setRef,
                handleKeyDown,
                handleMouseDown,
            }}
        />
    );
};

export const with2dArrowNavigation = Component => (props) => {
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    const refs = {};

    const setRef = (y, x) => (ref) => {
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
        if (!refs[y]) refs[y] = {};
        refs[y][x] = ref;
    };

    const [currentId, setCurrentId] = React.useState([minX, minY]);

    const handleArrowLeft = () => setCurrentId(([y, x]) => [y, Math.max(minX, x - 1)]);
    const handleArrowUp = () => setCurrentId(([y, x]) => [Math.max(minY, y - 1), x]);
    const handleArrowRight = () => setCurrentId(([y, x]) => [y, Math.min(maxX, x + 1)]);
    const handleArrowDown = () => setCurrentId(([y, x]) => [Math.min(maxY, y + 1), x]);

    const handleKeyDown = (event) => {
        if (event.ctrlKey || event.shiftKey || event.altKey || event.metaKey) {
            return undefined;
        }

        if (event.keyCode >= 37 && event.keyCode <= 40) {
            event.preventDefault();
        }

        switch (event.keyCode) {
        case 37: return handleArrowLeft();
        case 38: return handleArrowUp();
        case 39: return handleArrowRight();
        case 40: return handleArrowDown();
        default: return undefined;
        }
    };

    const handleMouseDown = (y, x) => () => setCurrentId([y, x]);

    React.useEffect(() => {
        const [y, x] = currentId;
        const ref = refs[y]?.[x];
        if (ref) ref.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentId]);

    return (
        <Component
            {...props}
            navigation={{
                setRef,
                handleKeyDown,
                handleMouseDown,
            }}
        />
    );
};

export default {
    with1dArrowNavigation,
    with2dArrowNavigation,
};
